/* @ngInject */
const areaCtrl = (
  $scope,
  $$area,
  $$railway
) => {
  $scope.$$area = $$area
  $scope.$$railway = $$railway
}

export default areaCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/area/area.controller.js